(function () {
  const DEFAULT_ENDPOINT = 'https://cavern-app-backend.onrender.com/api/openai/ask-vern';

  const STARTER_MESSAGE =
    'Hey! I am Vern. Ask me about games, trade-ins, rewards, store info, or what to play next.';

  const ACCURACY_INSTRUCTIONS = [
    'Prioritize correctness over speed, confidence, or agreeableness.',
    'For factual questions about game codes, release details, compatibility, variants, or prices, verify against reliable sources or current store data before answering when possible.',
    'If a claim is uncertain or source data is unavailable, say that plainly and ask a clarifying question or suggest how to verify it.',
    'Do not invent product availability, related merchandise, cheat codes, policies, dates, variants, or source-backed facts.',
    'Correct the customer politely when a premise is wrong; do not mirror an incorrect assumption just to be agreeable.',
    'Do not give trade-in values, quotes, or estimates over phone or chat. Trade-in value requires in-person inspection and testing. Collection/app estimates are non-binding ranges only, not final offers.',
    'For a specific game lookup, include at most one short factual game blurb before product listings when you can answer accurately; skip the blurb if you are not sure.',
    'Do not include raw product links or tell customers to search the site when product cards or listings are available.'
  ].join(' ');

  const DEFAULT_CHIPS = [
    ['Trade-ins', 'How do trade-ins work at The Video Game Cavern?'],
    ['Rewards', 'How do Cavern rewards work?'],
    ['Order help', 'I need help with an order. What should I do?'],
    ['Store hours', 'What are your hours?'],
    ['Find a game', 'Help me find a game to buy.']
  ];

  const FAQS = {
    address: '3058 Wade Hampton Blvd Suite 24, Taylors, SC 29687',
    hours: 'Mon - Fri 12pm-8pm; Saturday 12pm-9pm; Sunday 12pm-8pm',
    phone: '864-322-2003',
    email: 'Sales@thevideogamecavern.com',
    returns: 'All sales final; 30-day defect guarantee with receipt for exchange or store credit.',
    shipping: 'We ship within 1-3 business days; tracking is emailed on dispatch.'
  };

  const FAQ_PATTERNS = {
    address: [
      /\b(?:address|location|directions?)\b/i,
      /\bwhere\s+(?:are|is)\s+(?:you|your|the\s+store|the\s+cavern)\b/i,
      /\bhow\s+(?:do|can)\s+i\s+(?:find|get\s+to|visit)\s+(?:you|the\s+store|the\s+cavern)\b/i
    ],
    hours: [
      /^\s*(?:hours|open|closed?|closing)\??\s*$/i,
      /\b(?:store\s+)?hours\b/i,
      /\bwhat\s+time\s+(?:do|does|are)\s+(?:you|the\s+store|the\s+cavern)\s+(?:open|close)\b/i,
      /\bwhen\s+(?:are|do|does)\s+(?:you|the\s+store|the\s+cavern)\s+(?:open|close|closing)\b/i,
      /\b(?:are\s+you|is\s+the\s+store|is\s+the\s+cavern)\s+open\b/i,
      /\b(?:open|close|closing)\s+(?:today|tomorrow|tonight|on\s+\w+|this\s+\w+)\b/i
    ],
    returns: [
      /^\s*(?:returns?|refunds?|exchanges?|defects?)\??\s*$/i,
      /\b(?:return|returns|refund|exchange)\s+(?:policy|window|process)\b/i,
      /\b(?:defect|defective)\s+(?:guarantee|return|returns|exchange|policy)\b/i,
      /\bcan\s+i\s+(?:return|refund|exchange)\b/i,
      /\bhow\s+do\s+(?:returns|exchanges|refunds)\s+work\b/i,
      /\bwhat(?:'s|\s+is)\s+your\s+(?:return|refund|exchange)\s+policy\b/i
    ],
    shipping: [
      /^\s*(?:shipping|ship|delivery|tracking)\??\s*$/i,
      /\b(?:shipping|delivery|tracking)\b/i,
      /\bwhen\s+will\s+(?:it|my\s+order)\s+ship\b/i,
      /\bdo\s+you\s+ship\b/i
    ],
    phone: [
      /^\s*(?:phone|telephone|phone\s+number|number|call)\??\s*$/i,
      /\b(?:phone|telephone)\s+number\b/i,
      /\bwhat(?:'s|\s+is)\s+(?:your|the\s+store'?s?)\s+(?:phone|telephone|number)\b/i,
      /\bhow\s+(?:can|do)\s+i\s+(?:call|phone|contact)\s+(?:you|the\s+store|the\s+cavern)\b/i,
      /\bcan\s+i\s+call\s+(?:you|the\s+store|the\s+cavern)\b/i
    ],
    email: [
      /^\s*(?:email|e-mail|contact)\??\s*$/i,
      /\b(?:email|e-mail)\s+(?:address)?\b/i,
      /\bwhat(?:'s|\s+is)\s+(?:your|the\s+store'?s?)\s+(?:email|e-mail)\b/i,
      /\bhow\s+(?:can|do)\s+i\s+(?:email|contact)\s+(?:you|the\s+store|the\s+cavern)\b/i
    ]
  };

  const FAQ_LABELS = {
    address: 'Our address',
    hours: 'Our hours',
    phone: 'Phone',
    email: 'Email',
    returns: 'Returns',
    shipping: 'Shipping'
  };

  const DISAMBIGUATION_RULES = [
    {
      pattern: /\b(?:smb3|mario(?:\s+(?:bros\.?|brothers))?\s*3)\b/i,
      heading: 'Did you mean one of these Mario 3 games?',
      chips: [
        ['Super Mario Bros. 3 - NES', 'Super Mario Bros. 3 NES'],
        ['Super Mario Advance 4 - GBA', 'Super Mario Advance 4 GBA'],
        ['Super Mario All-Stars - SNES', 'Super Mario All-Stars SNES'],
        ['Show all Mario 3', 'Mario 3']
      ]
    },
    {
      pattern: /\bzelda\s*(3|iii)\b/i,
      heading: 'Which Zelda 3?',
      chips: [
        ['A Link to the Past - SNES', 'The Legend of Zelda: A Link to the Past SNES'],
        ['A Link to the Past - GBA', 'A Link to the Past GBA']
      ]
    },
    {
      pattern: /\bsonic\s*2\b/i,
      heading: 'Which Sonic 2?',
      chips: [
        ['Sonic 2 - Genesis', 'Sonic the Hedgehog 2 Genesis'],
        ['Sonic 2 - Game Gear', 'Sonic the Hedgehog 2 Game Gear']
      ]
    }
  ];

  const PLATFORM_DETAIL_PATTERN =
    /\b(?:nes|snes|n64|nintendo\s*64|gamecube|game\s*cube|wii\s*u?|switch(?:\s*2)?|game\s*boy|gb|gbc|gba|advance|ds|3ds|playstation|ps[1-5]|psx|psp|vita|xbox(?:\s*(?:360|one|series\s*[sx]?))?|genesis|mega\s*drive|sega|saturn|dreamcast|game\s*gear|atari|pc|steam)\b/i;

  const PRODUCT_PLATFORM_FILTERS = [
    { label: 'NES', queryPattern: /\b(?:nes|nintendo\s+entertainment\s+system)\b/i, productPattern: /\b(?:nes|nintendo\s+entertainment\s+system)\b/i },
    { label: 'SNES', queryPattern: /\b(?:snes|super\s+nintendo)\b/i, productPattern: /\b(?:snes|super\s+nintendo)\b/i },
    { label: 'Nintendo 64', queryPattern: /\b(?:n64|nintendo\s*64)\b/i, productPattern: /\b(?:n64|nintendo\s*64)\b/i },
    { label: 'GameCube', queryPattern: /\bgame\s*cube\b/i, productPattern: /\bgame\s*cube\b/i },
    { label: 'Wii U', queryPattern: /\bwii\s*u\b/i, productPattern: /\bwii\s*u\b/i },
    { label: 'Wii', queryPattern: /\bwii\b/i, productPattern: /\bwii\b/i },
    { label: 'Switch', queryPattern: /\bswitch(?:\s*2)?\b/i, productPattern: /\bswitch(?:\s*2)?\b/i },
    { label: 'Game Boy Advance', queryPattern: /\b(?:gba|game\s*boy\s*advance)\b/i, productPattern: /\b(?:gba|game\s*boy\s*advance)\b/i },
    { label: 'Game Boy Color', queryPattern: /\b(?:gbc|game\s*boy\s*color)\b/i, productPattern: /\b(?:gbc|game\s*boy\s*color)\b/i },
    { label: 'Game Boy', queryPattern: /\b(?:gb|game\s*boy)\b/i, productPattern: /\b(?:gb|game\s*boy)\b/i },
    { label: '3DS', queryPattern: /\b3ds\b/i, productPattern: /\b3ds\b/i },
    { label: 'DS', queryPattern: /\bds\b/i, productPattern: /\bds\b/i },
    { label: 'PS5', queryPattern: /\bps5\b/i, productPattern: /\bps5\b/i },
    { label: 'PS4', queryPattern: /\bps4\b/i, productPattern: /\bps4\b/i },
    { label: 'PS3', queryPattern: /\bps3\b/i, productPattern: /\bps3\b/i },
    { label: 'PS2', queryPattern: /\bps2\b/i, productPattern: /\bps2\b/i },
    { label: 'PS1', queryPattern: /\b(?:ps1|psx)\b/i, productPattern: /\b(?:ps1|psx|playstation)\b/i },
    { label: 'PSP', queryPattern: /\bpsp\b/i, productPattern: /\bpsp\b/i },
    { label: 'Vita', queryPattern: /\bvita\b/i, productPattern: /\bvita\b/i },
    { label: 'Xbox Series', queryPattern: /\bxbox\s+series\b/i, productPattern: /\bxbox\s+series\b/i },
    { label: 'Xbox One', queryPattern: /\bxbox\s+one\b/i, productPattern: /\bxbox\s+one\b/i },
    { label: 'Xbox 360', queryPattern: /\bxbox\s*360\b/i, productPattern: /\bxbox\s*360\b/i },
    { label: 'Original Xbox', queryPattern: /\boriginal\s+xbox\b/i, productPattern: /\b(?:original\s+)?xbox\b/i },
    { label: 'Genesis', queryPattern: /\b(?:genesis|mega\s*drive)\b/i, productPattern: /\b(?:genesis|mega\s*drive)\b/i },
    { label: 'Dreamcast', queryPattern: /\bdreamcast\b/i, productPattern: /\bdreamcast\b/i },
    { label: 'Game Gear', queryPattern: /\bgame\s*gear\b/i, productPattern: /\bgame\s*gear\b/i },
    { label: 'PlayStation', queryPattern: /\bplaystation\s+games\b/i, productPattern: /\b(?:playstation|ps[1-5]|psx|psp|vita)\b/i },
    { label: 'Xbox', queryPattern: /\bxbox\s+games\b/i, productPattern: /\bxbox\b/i },
    { label: 'Nintendo', queryPattern: /\bnintendo\s+games\b/i, productPattern: /\b(?:nes|snes|n64|nintendo\s*64|game\s*cube|wii|switch|game\s*boy|gb|gbc|gba|ds|3ds)\b/i },
    { label: 'Handhelds', queryPattern: /\bhandheld\s+games\b/i, productPattern: /\b(?:game\s*boy|gb|gbc|gba|ds|3ds|psp|vita|game\s*gear)\b/i }
  ];

  const CATALOG_INTENT_PATTERN =
    /\b(?:do\s+you\s+have|have\s+you\s+got|got\s+any|looking\s+for|search(?:ing)?\s+for|find\s+me|show\s+me|i\s+(?:want|need|am\s+looking\s+for)|any)\b/i;

  const GENERIC_CATALOG_WORDS =
    /\b(?:do|you|have|got|any|a|an|the|for|looking|searching|search|find|me|show|i|want|need|games?|products?|copies|titles?|stuff)\b/gi;

  const PLATFORM_CHIP_SETS = {
    nintendo: [
      ['NES', '{series} NES games'],
      ['SNES', '{series} SNES games'],
      ['Nintendo 64', '{series} Nintendo 64 games'],
      ['GameCube', '{series} GameCube games'],
      ['Wii / Wii U', '{series} Wii Wii U games'],
      ['Switch', '{series} Nintendo Switch games'],
      ['Game Boy / DS', '{series} Game Boy DS games'],
      ['Show all', '{series} products']
    ],
    playstationXbox: [
      ['PS2 / PS3', '{series} PS2 PS3 games'],
      ['PS4 / PS5', '{series} PS4 PS5 games'],
      ['Xbox / 360', '{series} Xbox Xbox 360 games'],
      ['Xbox One / Series', '{series} Xbox One Xbox Series games'],
      ['Nintendo versions', '{series} Nintendo games'],
      ['Show all', '{series} products']
    ],
    mixed: [
      ['PlayStation', '{series} PlayStation games'],
      ['Xbox', '{series} Xbox games'],
      ['Nintendo', '{series} Nintendo games'],
      ['Switch', '{series} Nintendo Switch games'],
      ['Handhelds', '{series} handheld games'],
      ['Show all', '{series} products']
    ],
    pokemon: [
      ['Game Boy / GBA', 'Pokemon Game Boy Game Boy Advance games'],
      ['DS / 3DS', 'Pokemon DS 3DS games'],
      ['Switch', 'Pokemon Nintendo Switch games'],
      ['Pokemon TCG', 'Pokemon TCG products'],
      ['Show all', 'Pokemon products']
    ],
    sports: [
      ['PlayStation', '{series} PlayStation games'],
      ['Xbox', '{series} Xbox games'],
      ['Nintendo', '{series} Nintendo games'],
      ['Current gen', '{series} PS5 Xbox Series Switch games'],
      ['Older systems', '{series} PS2 PS3 Xbox 360 Wii games'],
      ['Show all', '{series} products']
    ],
    xboxOnly: [
      ['Original Xbox', '{series} Original Xbox games'],
      ['Xbox 360', '{series} Xbox 360 games'],
      ['Xbox One / Series', '{series} Xbox One Xbox Series games'],
      ['Show all', '{series} products']
    ]
  };

  const FRANCHISE_CLARIFICATION_RULES = [
    { series: 'Mario', pattern: /\bmario\b/i, chipSet: 'nintendo' },
    { series: 'Zelda', pattern: /\b(?:zelda|legend\s+of\s+zelda)\b/i, chipSet: 'nintendo' },
    { series: 'Pokemon', pattern: /\bpok[eé]mon\b/i, chipSet: 'pokemon' },
    { series: 'Sonic', pattern: /\bsonic\b/i, chipSet: 'mixed' },
    { series: 'Kirby', pattern: /\bkirby\b/i, chipSet: 'nintendo' },
    { series: 'Donkey Kong', pattern: /\bdonkey\s+kong\b/i, chipSet: 'nintendo' },
    { series: 'Metroid', pattern: /\bmetroid\b/i, chipSet: 'nintendo' },
    { series: 'Call of Duty', pattern: /\b(?:call\s+of\s+duty|cod)\b/i, chipSet: 'playstationXbox' },
    { series: 'Battlefield', pattern: /\bbattlefield\b/i, chipSet: 'playstationXbox' },
    { series: 'Resident Evil', pattern: /\bresident\s+evil\b/i, chipSet: 'mixed' },
    { series: 'Final Fantasy', pattern: /\bfinal\s+fantasy\b/i, chipSet: 'mixed' },
    { series: 'Dragon Quest', pattern: /\bdragon\s+quest\b/i, chipSet: 'mixed' },
    { series: 'Kingdom Hearts', pattern: /\bkingdom\s+hearts\b/i, chipSet: 'mixed' },
    { series: 'Grand Theft Auto', pattern: /\b(?:grand\s+theft\s+auto|gta)\b/i, chipSet: 'playstationXbox' },
    { series: 'Halo', pattern: /\bhalo\b/i, chipSet: 'xboxOnly' },
    { series: "Assassin's Creed", pattern: /\bassassin'?s\s+creed\b/i, chipSet: 'playstationXbox' },
    { series: 'Mortal Kombat', pattern: /\bmortal\s+kombat\b/i, chipSet: 'mixed' },
    { series: 'Street Fighter', pattern: /\bstreet\s+fighter\b/i, chipSet: 'mixed' },
    { series: 'Tekken', pattern: /\btekken\b/i, chipSet: 'mixed' },
    { series: 'Madden', pattern: /\bmadden\b/i, chipSet: 'sports' },
    { series: 'NBA 2K', pattern: /\bnba\s*2k\b/i, chipSet: 'sports' },
    { series: 'FIFA', pattern: /\bfifa\b/i, chipSet: 'sports' },
    { series: 'LEGO', pattern: /\blego\b/i, chipSet: 'mixed' },
    { series: 'Minecraft', pattern: /\bminecraft\b/i, chipSet: 'mixed' }
  ];

  const CATALOG_QUERY_ALIASES = [
    {
      pattern: /\bmario\s*kart\s*64\b/i,
      query: 'Do you have Mario Kart 64 for Nintendo 64?'
    },
    {
      pattern: /\bbeetle\s+adventures?(?:\s+racing)?\b/i,
      query: 'Do you have Beetle Adventure Racing for Nintendo 64?'
    }
  ];

  const INFO_LISTING_QUERY_RULES = [
    {
      pattern: /\bmario\s*kart\s*64\b/i,
      query: 'Do you have Mario Kart 64 for Nintendo 64?'
    },
    {
      pattern: /\b(?:super\s+)?mario\s*64\b/i,
      query: 'Do you have Super Mario 64 for Nintendo 64?'
    },
    {
      pattern: /\bbeetle\s+adventures?(?:\s+racing)?\b/i,
      query: 'Do you have Beetle Adventure Racing for Nintendo 64?'
    }
  ];

  const VERIFIED_ANSWER_RULES = [
    {
      pattern: /\b(?:super\s*c|super\s+contra)\b/i,
      intent: /\b(?:10|ten|30|thirty|man|men|lives?|life|code|cheat|konami)\b/i,
      answer:
        'Correction: Super C on the North American NES does not use the classic Contra 30-lives Konami Code. At the title screen, enter: Right, Left, Down, Up, A, B, Start. On the NES version, that gives 10 lives. The 30-life result is for the Japanese Famicom version, Super Contra.'
    },
    {
      pattern: /\bcontra\b/i,
      intent: /\b(?:30|thirty|50|fifty|100|hundred|man|men|lives?|life|code|cheat|konami)\b/i,
      answer:
        'Correction: NES Contra has the famous 30-lives code, not a 50- or 100-lives code. At the title screen, enter: Up, Up, Down, Down, Left, Right, Left, Right, B, A, Start. For two players, use Select before Start. That starts you with 30 lives.'
    },
    {
      pattern: /\bmario\b/i,
      intent: /\b(?:iup|1\s*[- ]?\s*up|one\s*[- ]?\s*up)\s+trick\b/i,
      answer:
        'I think you mean the 1-Up trick, not IUP. In Mario games, a 1-Up means an extra life, but the exact trick depends on the game. In Super Mario Bros. on NES, extra lives can come from 1-Up Mushrooms, 100 coins, Koopa shell/enemy chains, or bouncing on enemies successively without touching the ground. Tell me which Mario game or level and I can narrow it down.'
    },
    {
      pattern: /\b(?:trade[\s-]?ins?|sell(?:ing)?|cash\s+for|buy\s+my|value|values|valued|worth|estimate|quote|apprais(?:al|e)|offer)\b/i,
      intent: /\b(?:game|games|console|consoles|system|systems|controller|controllers|collection|cards?|pokemon|tcg|amiibo|disc|discs|cart|carts|cartridge|cartridges|gear|stuff|trade[\s-]?ins?|sell(?:ing)?|cash|value|values|worth|estimate|quote|offer)\b/i,
      answer:
        'For trade-ins, we need to see the items in person and test them before giving a value. Condition, completeness, authenticity, working order, and current demand all matter, so we do not give trade-in values over the phone or chat. You can bring games, systems, accessories, and related items to The Video Game Cavern for review. The coming app and website collection feature may show an estimated range for planning, but that is not a final offer or guarantee.'
    }
  ];

  const BLOCKED_CONTENT =
    /\b(porn|nsfw|xxx|erotic|sexual|sex positions?|boobs?|bewbs?|breasts?|tits?|ass(?:es)?|butts?|booty|penis|dick|cock|balls?|vagina|pussy|cum|semen|nude|nudity|naked|upskirt|fetish|hentai|fuk|fck|fuck\w*|motherfuck\w*|bitch(?:es|ing)?|whore|sluts?|cunt|twat|rape|raped|raping|rapist|p(?:ae|e)d(?:o|ophile|ophilia)s?|nambla|nmbla|underage|incest|molest\w*|groom(?:ing|er)s?|lolicon|shotacon|onlyfans|milf|horny|adult[-\s]?themed|purple\s+\w*head\w*\s+warrior|get\s+laid|hook\s*ups?|dating|single\s+(?:girls?|women|men|guys?)\s+near\s+me|hot\s+single)\b/i;

  const MATURE_TITLE_EXCEPTIONS = [
    /\bbmx\s*x{3}\b/i,
    /\bbeat\s+['’]?em\s+(?:and|&)\s+eat\s+['’]?em\b/i,
    /\b(?:grand\s+theft\s+auto|gta)\b/i
  ];

  const SAFE_MATURE_TITLE_REMAINDER =
    /\b(?:do|you|have|got|any|a|an|the|for|looking|searching|search|find|me|show|i|want|need|is|there|with|game|games|product|products|title|titles|copy|copies|disc|cart|cartridge|cib|loose|manual|box|case|price|stock|available|availability|version|versions|platform|console|please|on|in|nes|snes|n64|nintendo\s*64|gamecube|game\s*cube|wii|wii\s*u|switch|game\s*boy|gb|gbc|gba|advance|ds|3ds|playstation|ps1|ps2|ps3|ps4|ps5|psx|psp|vita|xbox|xbox\s*360|xbox\s*one|xbox\s*series|genesis|dreamcast|saturn|game\s*gear)\b/gi;

  class AskVernChat extends HTMLElement {
    constructor() {
      super();
      this.messages = [{ role: 'assistant', content: STARTER_MESSAGE }];
      this.loading = false;
      this.abortController = null;
      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onInputKeydown = this.onInputKeydown.bind(this);
      this.onLauncherClick = this.onLauncherClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
    }

    connectedCallback() {
      this.endpoint = this.dataset.endpoint || DEFAULT_ENDPOINT;
      this.mode = this.dataset.mode || 'floating';
      this.launcher = this.querySelector('[data-ask-vern-launcher]');
      this.closeButton = this.querySelector('[data-ask-vern-close]');
      this.messagesEl = this.querySelector('[data-ask-vern-messages]');
      this.chipsEl = this.querySelector('[data-ask-vern-chips]');
      this.form = this.querySelector('[data-ask-vern-form]');
      this.input = this.querySelector('[data-ask-vern-input]');
      this.submitButton = this.querySelector('[data-ask-vern-submit]');

      this.launcher?.addEventListener('click', this.onLauncherClick);
      this.closeButton?.addEventListener('click', this.onCloseClick);
      this.form?.addEventListener('submit', this.onSubmit);
      this.input?.addEventListener('input', this.onInput);
      this.input?.addEventListener('keydown', this.onInputKeydown);
      document.addEventListener('keydown', this.onDocumentKeydown);

      if (this.mode === 'page') {
        this.dataset.open = 'true';
      }

      this.renderMessages();
      this.renderChips(DEFAULT_CHIPS);
    }

    disconnectedCallback() {
      this.launcher?.removeEventListener('click', this.onLauncherClick);
      this.closeButton?.removeEventListener('click', this.onCloseClick);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('keydown', this.onInputKeydown);
      document.removeEventListener('keydown', this.onDocumentKeydown);
      this.abortController?.abort();
    }

    onLauncherClick() {
      this.setOpen(this.dataset.open !== 'true');
    }

    onCloseClick() {
      this.setOpen(false);
    }

    onDocumentKeydown(event) {
      if (event.key === 'Escape' && this.mode === 'floating' && this.dataset.open === 'true') {
        this.setOpen(false);
      }
    }

    setOpen(open) {
      this.dataset.open = open ? 'true' : 'false';
      this.launcher?.setAttribute('aria-expanded', open ? 'true' : 'false');
      const panel = this.querySelector('[data-ask-vern-panel]');
      panel?.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        window.setTimeout(() => this.input?.focus(), 40);
      } else {
        this.launcher?.focus();
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      await this.sendMessage(this.input?.value || '');
    }

    onInput() {
      if (!this.input) return;
      this.input.style.height = 'auto';
      this.input.style.height = `${Math.min(this.input.scrollHeight, 120)}px`;
    }

    onInputKeydown(event) {
      if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
      event.preventDefault();
      this.form?.requestSubmit();
    }

    async sendMessage(rawText) {
      const text = rawText.trim();
      if (!text || this.loading) return;

      this.input.value = '';
      this.input.style.height = '';
      this.clearChips();

      if (this.isBlockedContent(text)) {
        this.addMessage('assistant', 'That is not something I can help with. Ask me about games or store info.');
        return;
      }

      this.addMessage('user', text);

      const verifiedAnswer = this.tryVerifiedAnswer(text);
      if (verifiedAnswer) {
        this.addMessage('assistant', verifiedAnswer);
        return;
      }

      const disambiguation = this.tryDisambiguate(text);
      if (disambiguation) {
        this.addMessage('assistant', disambiguation.heading);
        this.renderChips(disambiguation.chips);
        return;
      }

      const faqAnswer = this.tryFaq(text);
      if (faqAnswer) {
        this.addMessage('assistant', faqAnswer);
        return;
      }

      await this.askAi(this.catalogQueryFor(text));
    }

    async askAi(text) {
      this.setLoading(true);
      this.abortController?.abort();
      this.abortController = new AbortController();

      try {
        const data = await this.fetchAskVern(text);
        const listingQuery = this.infoListingQueryFor(text);
        let rawProducts = this.productsFromResponse(data);
        let productQuery = text;
        let productsFromCompanionLookup = false;

        if (!rawProducts.length && listingQuery && listingQuery !== text) {
          const listingData = await this.fetchAskVern(listingQuery, { productOnly: true });
          const listingProducts = this.productsFromResponse(listingData);

          if (listingProducts.length) {
            rawProducts = listingProducts;
            productQuery = listingQuery;
            productsFromCompanionLookup = true;
          }
        }

        const platformFilters = this.productPlatformFiltersForQuery(productQuery);
        const products = this.filterProductsForQuery(rawProducts, platformFilters).slice(0, 5);
        const answer = this.productAnswerFromResponse(data, {
          products,
          rawProducts,
          platformFilters,
          preserveAnswerWithProducts: productsFromCompanionLookup
        });

        this.addMessage('assistant', answer, { products });
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.addMessage('assistant', `Vern could not answer right now. ${this.shortError(error)}`);
        }
      } finally {
        this.setLoading(false);
      }
    }

    async fetchAskVern(text, { productOnly = false } = {}) {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: text,
          productOnly,
          history: productOnly ? [] : this.recentHistory(),
          accuracyInstructions: ACCURACY_INSTRUCTIONS
        }),
        signal: this.abortController.signal
      });

      if (!response.ok) {
        const message = await this.errorMessageFromResponse(response);
        throw new Error(message);
      }

      return response.json();
    }

    recentHistory() {
      const history = this.messages
        .filter((message) => message.role === 'user' || message.role === 'assistant')
        .map((message) => ({ role: message.role, content: message.content }));

      // sendMessage has already displayed the current turn; message carries it once.
      if (history[history.length - 1]?.role === 'user') history.pop();

      return history.length <= 8 ? history : history.slice(history.length - 8);
    }

    tryVerifiedAnswer(query) {
      const rule = VERIFIED_ANSWER_RULES.find((item) => item.pattern.test(query) && item.intent.test(query));
      return rule ? rule.answer : '';
    }

    isBlockedContent(text) {
      if (!BLOCKED_CONTENT.test(text)) return false;
      return !this.isAllowedMatureTitleQuery(text);
    }

    isAllowedMatureTitleQuery(text) {
      const titlePattern = MATURE_TITLE_EXCEPTIONS.find((pattern) => pattern.test(text));
      if (!titlePattern) return false;

      const remainder = String(text || '')
        .replace(titlePattern, ' ')
        .toLowerCase()
        .replace(SAFE_MATURE_TITLE_REMAINDER, ' ')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      return remainder === '';
    }

    tryDisambiguate(query) {
      const exactRule = DISAMBIGUATION_RULES.find((rule) => rule.pattern.test(query));
      if (exactRule) return exactRule;

      return this.tryFranchiseClarification(query);
    }

    tryFranchiseClarification(query) {
      if (PLATFORM_DETAIL_PATTERN.test(query)) return null;

      const rule = FRANCHISE_CLARIFICATION_RULES.find((item) => item.pattern.test(query));
      if (!rule) return null;

      if (!CATALOG_INTENT_PATTERN.test(query) && !this.isBareFranchiseQuery(query, rule)) return null;

      return {
        heading: `Which ${rule.series} platform are you looking for?`,
        chips: this.platformChipsFor(rule)
      };
    }

    isBareFranchiseQuery(query, rule) {
      const remainder = String(query || '').replace(rule.pattern, '');
      return this.normalizeCatalogText(remainder) === '';
    }

    normalizeCatalogText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(GENERIC_CATALOG_WORDS, ' ')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    platformChipsFor(rule) {
      const templates = PLATFORM_CHIP_SETS[rule.chipSet] || PLATFORM_CHIP_SETS.mixed;
      return templates.map(([label, message]) => [
        label,
        message.replace(/\{series\}/g, rule.series)
      ]);
    }

    tryFaq(text) {
      for (const [key, patterns] of Object.entries(FAQ_PATTERNS)) {
        if (patterns.some((pattern) => pattern.test(text))) {
          return `${FAQ_LABELS[key] || key}: ${FAQS[key]}`;
        }
      }

      return null;
    }

    catalogQueryFor(text) {
      if (this.isInfoLookupQuestion(text)) return text;

      const alias = CATALOG_QUERY_ALIASES.find((item) => item.pattern.test(text));
      return alias ? alias.query : text;
    }

    infoListingQueryFor(text) {
      const rule = INFO_LISTING_QUERY_RULES.find((item) => item.pattern.test(text));
      return rule ? rule.query : '';
    }

    isInfoLookupQuestion(text) {
      return /\b(?:what\s+is|what's|whats|tell\s+me\s+about|info(?:rmation)?\s+(?:on|about)|describe|who\s+(?:made|developed|published)|when\s+(?:did|was)|release\s+date|how\s+(?:do|does|is))\b/i.test(
        text
      );
    }

    async errorMessageFromResponse(response) {
      try {
        const data = await response.json();
        if (data && data.message) return String(data.message);
      } catch (error) {
        // Ignore body parsing errors and show the HTTP status.
      }
      return `HTTP ${response.status}`;
    }

    answerFromChatCompletion(data) {
      if (!data || typeof data !== 'object') return 'Hmm, I could not find that.';

      const directAnswer = this.firstText(
        data.answer,
        data.message,
        data.content,
        data.text,
        data.output_text
      );
      if (directAnswer) return directAnswer;

      const choices = Array.isArray(data.choices) ? data.choices : [];
      for (const choice of choices) {
        const choiceAnswer = this.firstText(
          choice?.message?.content,
          choice?.delta?.content,
          choice?.content,
          choice?.text
        );
        if (choiceAnswer) return choiceAnswer;
      }

      const output = Array.isArray(data.output) ? data.output : [];
      for (const item of output) {
        const outputAnswer = this.firstText(item?.content, item?.text);
        if (outputAnswer) return outputAnswer;
      }

      return 'Hmm, I could not find that.';
    }

    firstText(...values) {
      for (const value of values) {
        const text = this.textFromContent(value);
        if (text) return text;
      }

      return '';
    }

    textFromContent(value) {
      if (typeof value === 'string') return value.trim();
      if (typeof value === 'number') return String(value);
      if (!value || typeof value !== 'object') return '';

      if (Array.isArray(value)) {
        return value
          .map((item) => this.textFromContent(item))
          .filter(Boolean)
          .join('\n')
          .trim();
      }

      return this.firstText(value.text, value.value, value.content);
    }

    cleanAnswer(value, options = {}) {
      let answer = String(value || '')
        .replace(/(\r?\n){2,}/g, '\n')
        .replace(/[ \t]{2,}/g, ' ')
        .trim();

      if (options.stripProductLinks || this.hasRawCommerceLinks(answer)) {
        answer = this.stripProductLinks(answer);
      }

      return this.stripSpeculativeCommerceClaims(answer);
    }

    stripSpeculativeCommerceClaims(value) {
      return String(value || '')
        .replace(
          /\s*(?:if\s+you\s+want,?\s*)?(?:try\s+)?search(?:ing)?\s+["'][^"']+["']\s+on\s+(?:our|the)\s+(?:site|website|store)\s+for\s+(?:related\s+)?(?:games?|products?|items?|merchandise)(?:\s+or\s+(?:games?|products?|items?|merchandise))*[.!?]?/gi,
          ''
        )
        .replace(
          /\s*(?:for\s+classic\s+[^.!?]+,?\s*)?(?:try\s+)?search(?:ing)?\s+["'][^"']+["'](?:\s+plus\s+[^.!?]+?)?\s+on\s+(?:our|the)\s+(?:site|website|store)\s+for\s+[^.!?]*(?:guides?|related\s+items?|copies|products?|items?|merchandise)[^.!?]*[.!?]?/gi,
          ''
        )
        .replace(
          /\s*(?:if\s+you\s+want(?:\s+to\s+try\s+it)?,?\s*)?(?:try\s+)?search(?:ing)?\s+for\s+["'][^"']+["']\s+on\s+(?:our|the)\s+(?:site|website|store)\s+to\s+find\s+[^.!?]*(?:copies|guides?|products?|items?|merchandise)[^.!?]*[.!?]?/gi,
          ''
        )
        .replace(
          /\s*(?:if\s+you\s+want\s+to\s+find\s+(?:it|that)\s+(?:here|on\s+(?:our|the)\s+(?:site|website|store)),?\s*)?(?:try\s+)?search(?:ing)?\s+["'][^"']+["']\s+on\s+(?:our|the)\s+(?:site|website|store)[.!?]?/gi,
          ''
        )
        .replace(
          /\s*(?:(?:we|our\s+(?:store|site|website)|the\s+(?:store|site|website))\s+(?:may|might|could)\s+(?:have|carry|stock|offer)|you\s+(?:may|might|could)\s+find)\s+[^.!?]*(?:merchandise|products?|items?)[^.!?]*[.!?]?/gi,
          ''
        )
        .replace(
          /\s*(?:check|search|browse)\s+(?:our|the)\s+(?:site|website|store)\s+for\s+(?:related\s+)?(?:merchandise|products?|items?)[.!?]?/gi,
          ''
        )
        .replace(
          /\s*(?:check|search|browse)\s+(?:our|the)\s+[^.!?]*(?:category|collection)\s+for\s+[^.!?]*(?:copy|copies|cartridges?|manuals?|accessories|related\s+items?)[^.!?]*[.!?]?/gi,
          ''
        )
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/\s+([.!?,])/g, '$1')
        .replace(/(\r?\n){2,}/g, '\n')
        .trim();
    }

    hasRawCommerceLinks(value) {
      return /https?:\/\/(?:www\.)?thevideogamecavern\.com\/(?:products|search)\b/i.test(String(value || ''));
    }

    stripProductLinks(value) {
      const lines = String(value || '').split(/\r?\n/);
      const cleaned = [];
      let removedProductLinks = false;

      for (let index = 0; index < lines.length; index += 1) {
        const line = lines[index];
        const trimmed = line.trim();
        const nextTrimmed = (lines[index + 1] || '').trim();
        const upcomingLines = lines.slice(index + 1, index + 9);
        const upcomingHasUrl = upcomingLines.some((upcomingLine) => /https?:\/\//i.test(upcomingLine.trim()));

        if (/https?:\/\//i.test(trimmed)) {
          removedProductLinks = true;
          continue;
        }

        if (/^[-*]\s+.+:?\s*$/i.test(trimmed) && /^https?:\/\//i.test(nextTrimmed)) {
          removedProductLinks = true;
          index += 1;
          continue;
        }

        if (
          /^(?:here are|related links|product links|some related links)/i.test(trimmed) ||
          (/\b(?:possible matches|check these|matches on our site|product pages?)\b/i.test(trimmed) && upcomingHasUrl)
        ) {
          removedProductLinks = true;
          continue;
        }

        if (removedProductLinks && this.isProductLinkBoilerplate(trimmed)) {
          continue;
        }

        cleaned.push(line);
      }

      return cleaned
        .join('\n')
        .replace(/(\r?\n){2,}/g, '\n')
        .trim();
    }

    isProductLinkBoilerplate(value) {
      return /^(?:availability and prices|open the product pages?|you can also search|search .+ for more options|you can also call|call .+ for current options|let me know if you want recommendations)/i.test(
        String(value || '')
      );
    }

    productAnswerFromResponse(data, context) {
      const rawProducts = context.rawProducts || [];
      const products = context.products || [];
      const platformFilters = context.platformFilters || [];
      const rawAnswer = this.answerFromChatCompletion(data);
      const answerSummary = this.productSummaryFromAnswer(rawAnswer, rawProducts);

      if (rawProducts.length && products.length) {
        if (context.preserveAnswerWithProducts) {
          return this.productInfoAnswerWithListings(answerSummary, platformFilters, products);
        }

        return this.productMatchIntro(platformFilters, answerSummary);
      }

      if (rawProducts.length && !products.length && platformFilters.length) {
        return this.productFilteredNoMatchAnswer(platformFilters);
      }

      const answer = this.cleanAnswer(rawAnswer, {
        stripProductLinks: rawProducts.length > 0
      });

      if (!products.length && this.hasRawCommerceLinks(rawAnswer)) {
        const label = this.productFilterLabel(platformFilters);
        return label
          ? `Hmm, I do not have clean ${label} product cards to show yet. Try the exact title or a wider platform and I will narrow it down.`
          : 'Hmm, I do not have clean product cards to show yet. Try the exact title and I will narrow it down.';
      }

      if (!answer && products.length) return this.productMatchIntro([]);
      return answer || 'Hmm, I could not find that.';
    }

    productSummaryFromAnswer(rawAnswer, products = []) {
      const answer = this.stripProductTitleLines(
        this.cleanAnswer(rawAnswer, { stripProductLinks: true }),
        products
      );

      return answer && !this.isFallbackAnswer(answer) && !this.isMostlyProductListAnswer(answer) ? answer : '';
    }

    isFallbackAnswer(value) {
      return /^hmm,\s+i\s+could\s+not\s+find\s+that\.?$/i.test(String(value || '').trim());
    }

    stripProductTitleLines(value, products = []) {
      const titleSet = new Set(
        (products || [])
          .map((product) => this.normalizeProductTitle(product?.title))
          .filter(Boolean)
      );

      if (!titleSet.size) return value;

      return String(value || '')
        .split(/\r?\n/)
        .filter((line) => {
          const normalized = this.normalizeProductTitle(line.replace(/^[-*]\s*/, ''));
          return normalized && !titleSet.has(normalized) && !/^open product page$/i.test(line.trim());
        })
        .join('\n')
        .trim();
    }

    normalizeProductTitle(value) {
      return String(value || '')
        .replace(/\[[^\]]+\]\([^)]*\)/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    productMatchIntro(platformFilters, answerSummary = '') {
      const label = this.productFilterLabel(platformFilters);
      const intro = label
        ? `Nice, that narrows it down. I found these ${label} matches.`
        : 'Nice, I found a few close matches. Take a look.';

      return [intro, answerSummary].filter(Boolean).join('\n');
    }

    productInfoAnswerWithListings(answer, platformFilters, products = []) {
      const listingLine = this.productListingLine(platformFilters);
      return [answer, listingLine]
        .filter(Boolean)
        .join('\n');
    }

    productListingLine(platformFilters) {
      const label = this.productFilterLabel(platformFilters);
      return label
        ? `I found ${label} listings below too, so you can open a product page to buy it or join the waitlist.`
        : 'I found listings below too, so you can open a product page to buy it or join the waitlist.';
    }

    productFilteredNoMatchAnswer(platformFilters) {
      return `Close, but the matches I found did not look like ${this.productFilterLabel(platformFilters)} games. Try the exact title or a wider platform and I will narrow it down.`;
    }

    isMostlyProductListAnswer(value) {
      return /\b(?:possible matches|closest matches|matches?\s+(?:i|we)\s+found|product pages?|availability and prices|search .+ for more options|check these|listings?\s+below|buy it or join the waitlist)\b/i.test(
        String(value || '')
      );
    }

    productPlatformFiltersForQuery(query) {
      let filters = PRODUCT_PLATFORM_FILTERS.filter((filter) => filter.queryPattern.test(query));

      if (/\bwii\s*u\b/i.test(query) && !/\bwii\s+wii\s*u\b/i.test(query)) {
        filters = filters.filter((filter) => filter.label !== 'Wii');
      }

      if (/\b(?:gba|game\s*boy\s*advance)\b/i.test(query) && !/\bgame\s*boy\s+game\s*boy\s*advance\b/i.test(query)) {
        filters = filters.filter((filter) => filter.label !== 'Game Boy');
      }

      if (/\b(?:gbc|game\s*boy\s*color)\b/i.test(query) && !/\bgame\s*boy\s+game\s*boy\s*color\b/i.test(query)) {
        filters = filters.filter((filter) => filter.label !== 'Game Boy');
      }

      return filters.sort((first, second) => this.platformFilterIndex(query, first) - this.platformFilterIndex(query, second));
    }

    platformFilterIndex(query, filter) {
      const match = String(query || '').match(filter.queryPattern);
      return match && typeof match.index === 'number' ? match.index : Number.MAX_SAFE_INTEGER;
    }

    filterProductsForQuery(products, platformFilters) {
      if (!platformFilters.length) return products;
      return products.filter((product) => this.productMatchesPlatformFilters(product, platformFilters));
    }

    productMatchesPlatformFilters(product, platformFilters) {
      const platformText = product.platformText || this.productPlatformText(product);
      return platformFilters.some((filter) => filter.productPattern.test(platformText));
    }

    productPlatformText(product) {
      const title = String(product?.title || '').trim();
      const explicit = [
        product?.platform,
        product?.console,
        product?.system,
        product?.productType,
        product?.type,
        Array.isArray(product?.tags) ? product.tags.join(' ') : product?.tags,
        product?.handle,
        product?.url,
        product?.onlineStoreUrl
      ]
        .filter(Boolean)
        .join(' ');
      const titlePlatform = this.titlePlatformSegment(title);

      return `${explicit} ${titlePlatform || (!explicit ? title : '')}`.trim();
    }

    titlePlatformSegment(title) {
      const parts = String(title || '').split(/\s+-\s+/);
      return parts.length > 1 ? parts[parts.length - 1].trim() : '';
    }

    productFilterLabel(platformFilters) {
      return platformFilters.map((filter) => filter.label).join(' / ');
    }

    shortError(error) {
      const text = String(error?.message || error || '').replace(/^Exception:\s*/, '').trim();
      if (!text) return 'Please try again in a second.';
      return text.length <= 110 ? text : `${text.slice(0, 110)}...`;
    }

    productsFromResponse(data) {
      if (!data || typeof data !== 'object' || !Array.isArray(data.products)) return [];

      return data.products
        .map((product) => ({
          title: String(product?.title || '').trim(),
          url: this.safeProductUrl(product?.url || product?.onlineStoreUrl),
          imageUrl: String(product?.imageUrl || '').trim(),
          imageAltText: String(product?.imageAltText || product?.title || '').trim(),
          platformText: this.productPlatformText(product)
        }))
        .filter((product) => product.title && product.url);
    }

    safeProductUrl(url) {
      const raw = String(url || '').trim();
      if (!raw) return '';

      try {
        const parsed = new URL(raw, window.location.origin);
        const host = parsed.hostname.toLowerCase();
        const currentHost = window.location.hostname.toLowerCase();
        const isCavernHost =
          host === currentHost ||
          host === 'thevideogamecavern.com' ||
          host === 'www.thevideogamecavern.com';

        if (parsed.protocol !== 'https:' || !isCavernHost || !parsed.pathname.startsWith('/products/')) {
          return '';
        }

        return parsed.pathname + parsed.search + parsed.hash;
      } catch (_) {
        return '';
      }
    }

    addMessage(role, content, extras = {}) {
      this.messages.push({ role, content, products: extras.products || [] });
      this.renderMessages();
    }

    setLoading(loading) {
      this.loading = loading;
      if (this.submitButton) this.submitButton.disabled = loading;
      if (this.input) this.input.disabled = loading;
      this.renderMessages();
    }

    renderMessages() {
      if (!this.messagesEl) return;

      this.messagesEl.innerHTML = '';
      for (const message of this.messages) {
        this.messagesEl.appendChild(this.createMessage(message));
      }
      if (this.loading) {
        this.messagesEl.appendChild(this.createMessage({ role: 'status', content: 'Thinking...' }));
      }
      this.messagesEl.scrollTop = this.messagesEl.scrollHeight;
    }

    createMessage(message) {
      const role = message.role;
      const item = document.createElement('div');
      item.className = `ask-vern__message ask-vern__message--${role}`;

      const bubble = document.createElement('div');
      bubble.className = 'ask-vern__message-bubble';
      bubble.textContent = message.content;
      item.appendChild(bubble);

      if (role === 'assistant' && Array.isArray(message.products) && message.products.length) {
        const products = document.createElement('div');
        products.className = 'ask-vern__products';

        message.products.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'ask-vern__product';
          link.href = product.url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';

          if (product.imageUrl) {
            const image = document.createElement('img');
            image.className = 'ask-vern__product-image';
            image.src = product.imageUrl;
            image.alt = product.imageAltText || '';
            image.loading = 'lazy';
            link.appendChild(image);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'ask-vern__product-image ask-vern__product-image--placeholder';
            placeholder.textContent = 'VG';
            link.appendChild(placeholder);
          }

          const copy = document.createElement('span');
          copy.className = 'ask-vern__product-copy';

          const title = document.createElement('span');
          title.className = 'ask-vern__product-title';
          title.textContent = product.title;

          const action = document.createElement('span');
          action.className = 'ask-vern__product-action';
          action.textContent = 'Open product page';

          copy.appendChild(title);
          copy.appendChild(action);
          link.appendChild(copy);
          products.appendChild(link);
        });

        item.appendChild(products);
      }

      return item;
    }

    renderChips(chips) {
      if (!this.chipsEl) return;
      this.clearChips();
      chips.forEach(([label, message]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ask-vern__chip';
        button.textContent = label;
        button.addEventListener('click', () => this.sendMessage(message));
        this.chipsEl.appendChild(button);
      });
    }

    clearChips() {
      if (this.chipsEl) this.chipsEl.innerHTML = '';
    }
  }

  if (!customElements.get('ask-vern-chat')) {
    customElements.define('ask-vern-chat', AskVernChat);
  }
})();
